import CssBaseline from '@material-ui/core/CssBaseline';
import { ThemeProvider } from '@material-ui/styles'; // eslint-disable-line import/no-extraneous-dependencies
import { defaultQueryFn, queryCacheStrategies } from 'api';
import React, { useEffect } from 'react';
import { hot } from 'react-hot-loader';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import useUploadStore from 'store/uploads/useUploadStore';
import theme from '../common/theme';
import AppRouter from '../navigation';
// import IdleTimerContainer from 'components/shared/IdleTimerContainer';
import { SessionStateProvider } from 'navigation/SessionState';
import { LocationProvider } from '@reach/router';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      queryFn: defaultQueryFn,
      ...(queryCacheStrategies.basic as any),
      retry: false,
    },
  },
});

const App: React.FC = () => {
  const initializeUploadStore = useUploadStore(
    (uploadStore) => uploadStore.initialize
  );
  useEffect(() => {
    initializeUploadStore();
  }, [initializeUploadStore]);

  return (
    <LocationProvider>
      <ThemeProvider theme={theme}>
        <QueryClientProvider client={queryClient}>
          <CssBaseline />
          <SessionStateProvider>
            {/* <IdleTimerContainer /> */}
            <AppRouter />
          </SessionStateProvider>
          <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
      </ThemeProvider>
    </LocationProvider>
  );
};

export default hot(module)(App);
